class PartnersSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", (e) => {
      if (!e.target.closest("[data-load-more]")) return;

      this.classList.add("partners--show-all");
    });
  }

  disconnectedCallback() {}
}

if (!customElements.get("partners-section")) {
  customElements.define("partners-section", PartnersSection);
}
